module.exports = __webpack_public_path__ + "static/import4-min-ebc18994240fd392564100cbea3d26b2.png";